import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Heart, Handshake, Users, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const ITEMS = [
    {
        icon: Heart,
        title: 'Donate',
        body: 'Support education, health and disaster relief programs. Every rupee is accounted for.',
        cta: 'Donate Now',
        to: '/donate',
        variant: 'accent',
        testId: 'multi-cta-donate',
    },
    {
        icon: Handshake,
        title: 'Partner (CSR)',
        body: 'Corporates: co-create outcome-driven CSR programs with transparent reporting.',
        cta: 'Explore Partnership',
        to: '/contact',
        variant: 'primary',
        testId: 'multi-cta-partner',
    },
    {
        icon: Users,
        title: 'Volunteer',
        body: 'Join 3,400+ volunteers driving change across Tamil Nadu and Puducherry.',
        cta: 'Sign Up as Volunteer',
        to: '/volunteer',
        variant: 'outline',
        testId: 'multi-cta-volunteer',
    },
];

const MultiCTASection = () => {
    const navigate = useNavigate();
    return (
        <section className="section-pad" data-testid="multi-cta">
            <div className="container-page">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                    {ITEMS.map((it, i) => {
                        const Icon = it.icon;
                        const isAccent = it.variant === 'accent';
                        const isPrimary = it.variant === 'primary';
                        return (
                            <motion.div
                                key={it.title}
                                initial={{ opacity: 0, y: 12 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4, delay: i * 0.06 }}
                                viewport={{ once: true, margin: '-60px' }}
                            >
                                <Card
                                    className={`h-full border-2 shadow-[0_10px_30px_rgba(15,23,42,0.05)] card-lift ${
                                        isAccent
                                            ? 'border-[hsl(var(--accent))]/40 bg-[hsl(var(--accent))]/5'
                                            : isPrimary
                                              ? 'border-[hsl(var(--primary))]/25 bg-[hsl(var(--primary))]/5'
                                              : 'border-border bg-card'
                                    }`}
                                >
                                    <CardContent className="p-7">
                                        <div
                                            className={`h-12 w-12 rounded-xl flex items-center justify-center mb-5 ${
                                                isAccent
                                                    ? 'bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))]'
                                                    : 'bg-[hsl(var(--primary))] text-primary-foreground'
                                            }`}
                                        >
                                            <Icon className="h-6 w-6" />
                                        </div>
                                        <div className="font-display font-semibold text-xl mb-2">
                                            {it.title}
                                        </div>
                                        <p className="text-sm text-foreground/80 leading-relaxed mb-5">
                                            {it.body}
                                        </p>
                                        <Button
                                            onClick={() => navigate(it.to)}
                                            className={
                                                isAccent
                                                    ? 'bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))] hover:bg-[hsl(var(--accent))]/90'
                                                    : isPrimary
                                                      ? 'bg-[hsl(var(--primary))] text-primary-foreground hover:bg-[hsl(var(--primary))]/90'
                                                      : ''
                                            }
                                            variant={
                                                isAccent || isPrimary ? 'default' : 'outline'
                                            }
                                            data-testid={it.testId}
                                        >
                                            {it.cta} <ArrowRight className="h-4 w-4 ml-1.5" />
                                        </Button>
                                    </CardContent>
                                </Card>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default MultiCTASection;
